import Fab from '@mui/material/Fab'
import { styled } from '@mui/material/styles'
// Define the styled Fab for positioning
const StyledFab = styled(Fab)(({ theme, position }) => ({
  position: 'absolute',
  bottom: '-12px', // Adjusted to position the button above the component
  right: '-12px', // Adjusted to position the button outside to the right
  zIndex: 1, // Ensure the button appears on top
  // transform: 'translate(50%, -50%)',
  boxShadow: theme.shadows[3], // Add shadow for visibility
  ...(position === 'bottom' ? { bottom: '-12px' } : { top: '-12px' }), //
}))

export default StyledFab
